module.exports = __webpack_public_path__ + "img/USA-Best-2070 - 2099.b7da37b8.png";